import React from 'react';

export const BanIcon = () => {
  const useTag = '<use xlink:href="#path-1" />';

  return (
    <svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Unavailable Icon</title>
      <defs>
        <circle id="path-1" cx="4.5" cy="4.5" r="4.5" />
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Unavailable-Icon">
          <g id="Group">
            <g>
              <mask id="mask-2" fill="white" dangerouslySetInnerHTML={{ __html: useTag }} />
              <circle stroke="#666666" cx="4.5" cy="4.5" r="4" />
              <polyline id="Path" stroke="#666666" mask="url(#mask-2)" points="0 9 4.61593602 4.38406398 9 0" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
